<div class="scroll-display map-display">
    <form [formGroup]="mapForm">
      <div>
        <div class="title-conteiner">
          <p class="title">Valide a localização do seu comércio</p>
        </div>
        <button class="close-btn" (click)="close()">X</button>
        <ng-container *ngIf="mapOptions.center && markerPosition && apiLoaded | async">
          <div class="map" [attr.data-testid]="'mapa'">
            <google-map
              (mapClick)="mapClick($event)"
              (zoomChanged)="zommChangedMap()"
              [options]="mapOptions"
              [zoom]="zoom"
              height="100%"
              width="100%"
            >
              <map-marker *ngIf="markerPosition" [position]="markerPosition" ></map-marker>
            </google-map>
          </div>
          <div *ngIf="mapOptions.center && markerPosition && !editingMarker" class="contenedor-botones">
            <div
            [attr.data-testid]="'warning-direccion-cobertura'"
            class="map-question parent-column"
            
          > 
            <span> Marcador e endereço não coincidem? </span>
            <a (click)="editingMarker = true">Ajustar</a>
          </div>
          <div class="contenedor">
            <button (click)="save()" mat-raised-button class="next-button" class="boton">Continuar</button>
          </div>
          </div>
         
          <div class="map-input-container" *ngIf="editingMarker">
            <div class="parent-column">
              <div class="parent">
                <div class="map-input-container-street">
                  <app-text-input
                    [attr.data-testid]="'direction'"
                    [placeholder]="'Rua'"
                    [labelText]="'Rua'"
                    formControlName="locationStreet"
                    [required]="true"
                    [submitted]="submitted || showErrorConfirm"
                  ></app-text-input>
                </div>
                <div class="map-input-container-location-street">
                  <app-text-input
                    class="map-input-street-location"
                    [placeholder]="'Número da Rua'"
                    [labelText]="'Número da Rua'"
                    [type]="'number'"
                    formControlName="locationStreetNumber"
                    [required]="!this.mapForm.get('noneNumberStreet')?.value"
                    [submitted]="submitted || showErrorConfirm"
                    [disabled]="this.mapForm.get('noneNumberStreet')?.value"
                  ></app-text-input>
                </div>
              </div>
            </div>
            <div class="parent-column-conteiner">
              <mat-checkbox formControlName="noneNumberStreet">Sem Número</mat-checkbox>
              <button (click)="confirm()" mat-raised-button class="buton-confirm">Confirmar</button>
            </div>
            <div [attr.data-testid]="'warning-direccion-cobertura'" class="map-state-warning" *ngIf="submitted">
              <span> Você deve confirmar o endereço para continuar </span>
            </div>
          </div>
        </ng-container>
      </div>
    </form>
  </div>
  